import React from 'react';
import { render } from '@testing-library/react';
import '@testing-library/jest-dom/extend-expect';
import { Breadcrumb } from './';

describe('Breadcrumb.Link', () => {
	it('should allow custom HTML element', () => {
		const props = {
			el: 'a' as const,
			label: 'label',
			href: 'https://en.wikipedia.org/wiki/Main_Page',
		};
		const { container } = render(<Breadcrumb.Link {...props} />);

		expect(container.firstChild).toBeInstanceOf(HTMLAnchorElement);
	});

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Breadcrumb>
				<Breadcrumb.Link
					label="Root page"
					data-auto-sel="automation-selector"
				/>
				<Breadcrumb.Link label="Subpage" />
				<Breadcrumb.Link label="Current page" aria-current="page" />
			</Breadcrumb>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
